import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { lifeFacets } from '../../data/landingBVisual';

/**
 * "Campus is more than class."
 *
 * A visual sequence rather than a feature grid: six photographs of the same
 * campus life, each labelled with a single verb. The words are the hierarchy;
 * there is deliberately no card chrome, no icon set and no supporting
 * paragraph per tile, because the photographs carry the meaning.
 */
export function LifeSequence() {
  return <section className="bg-[#faf8f3] py-16 lg:py-20" data-id="element-2647" data-mp="ipsyo4sgq52a">
      <div className="mx-auto grid max-w-[88rem] gap-10 px-4 sm:px-8 lg:grid-cols-[minmax(0,20rem)_minmax(0,1fr)] lg:items-center lg:gap-12" data-id="element-2648" data-mp="4p8hfd274haw">
        <div data-id="element-2649" data-mp="9p4ib3fljsm8">
          <h2 className="text-h1 font-bold leading-[1.1] tracking-tight text-ink" data-id="element-2650" data-mp="9ov0w48mats5">
            Campus is
            <br data-id="element-2651" data-mp="1z42kos98fhpy" />
            more than class.
          </h2>
          <p className="mt-5 max-w-[34ch] text-body leading-relaxed text-ink-muted" data-id="element-2652" data-mp="242mbb5yrthon">
            It&rsquo;s where you learn, live, connect, earn, discover and become who you&rsquo;re
            becoming.
          </p>
          <Link to="/register" className="group mt-6 inline-flex min-h-touch items-center gap-2 text-body font-semibold text-brand-800" data-id="element-2653" data-mp="2x48bq66sqrf8">
            See how it all comes together
            <ArrowRightIcon aria-hidden className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-1" data-id="element-2654" data-mp="36vmgasdluhf8" />
          </Link>
        </div>

        <ul className="cz-tabstrip grid grid-flow-col auto-cols-[9.5rem] gap-3 pb-2 sm:auto-cols-[11rem] lg:grid-flow-row lg:auto-cols-auto lg:grid-cols-6 lg:overflow-visible lg:pb-0" data-id="element-2655" data-mp="2e800mlr3rmc0">
          {lifeFacets.map(facet => <li key={facet.id} className="shrink-0" data-id="element-2656" data-mp="7fpizzmw9clu">
              <Link to={facet.to} className="group relative block overflow-hidden rounded-xl focus-visible:outline-none" data-id="element-2657" data-mp="7eeic8oqwkyy">
                <img src={facet.image} alt={facet.alt} loading="lazy" decoding="async" className="aspect-[3/4] w-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.05]" data-id="element-2658" data-mp="2w9494kpdxdg1" />
                <span aria-hidden className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/10 to-transparent" data-id="element-2659" data-mp="3a8lwcvn18ina" />
                <span className="absolute inset-x-0 bottom-0 p-3" data-id="element-2660" data-mp="2hjf0y5ivk969">
                  <span className="block text-body-sm font-bold uppercase tracking-[0.14em] text-white" data-id="element-2661" data-mp="2hhlv2sg35szb">
                    {facet.word}
                  </span>
                </span>
              </Link>
            </li>)}
        </ul>
      </div>
    </section>;
}